import React from 'react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import { InputGroup, Input, InputRightElement, Image } from '@chakra-ui/react';
import { calendarInput } from '../../assets/new-images/icons';

const IncludeDates = ({ periods, periodSelected, onChange }) => {
 return (
  <InputGroup display='grid' isolation='unset' width='220px'>
   <ReactDatePicker
    name='periodSelected'
    selected={periodSelected}
    onChange={onChange}
    locale='pt-BR'
    showPopperArrow={false}
    autoComplete='off'
    dateFormat='MMM/yy'
    includeDates={periods}
    showMonthYearPicker
    customInput={
     <Input
      autoComplete='off'
      _autofill={{
       bg: '#F5F5FB !important',
       WebkitBoxShadow: '0 0 0px 1000px #F5F5FB inset',
       WebkitTextFillColor: '#000000',
       transition: 'background-color 5000s ease-in-out 0s',
      }}
      type='text'
      _focusVisible={{
       borderColor: 'inherit',
      }}
      _disabled={{
       bg: '#E5E5E5',
       borderColor: '#DCCFEC',
       cursor: 'not-allowed',
      }}
     />
    }
   />
   <InputRightElement
    pointerEvents='none'
    display={'flex'}
    alignItems='center'
    h='100%'
    cursor='pointer'
   >
    <Image src={calendarInput} alt='calendar' mr='10px' height='23px' />
   </InputRightElement>
  </InputGroup>
 );
};

export default IncludeDates;
